import {RootBannerSection} from "./rootBannerSection";
import {FlashsaleType} from "../../helpers/loadFlashsales";
import {rootFlashsaleSlideRender} from "../organisms/flashsale/RootFlashsaleSlide";

export class RootFlashsaleSection {
  // Instances
  private readonly flashsaleSection: HTMLElement;
  private readonly flashsaleData: FlashsaleType[];
  private swiper?: RootBannerSection;
  private isRenderedCount: number;

  private isRenderedCallback = () => {
    if (++this.isRenderedCount === this.flashsaleData.length) {
      this.runRender();
    }
  };

  /**
   * ctor
   * @param flashsaleSection Section element holding flashsale swiper
   * @param flashsaleData Data loaded either from local sessionStorage or by fetch
   */
  constructor(flashsaleSection: HTMLElement, flashsaleData: FlashsaleType[]) {
    this.flashsaleSection = flashsaleSection;
    this.flashsaleData = flashsaleData;
    this.isRenderedCount = 0;
    this.initRender();
  }

  /**
   * Initialize all flashsales before swiper rendering
   */
  private initRender(): void {
    if (this.flashsaleData.length === 0) {
      const parent = this.flashsaleSection.parentElement;
      if (parent !== null) {
        parent.removeChild(this.flashsaleSection);
      }

      return;
    }

    // Iterate over flashsales
    const flashsaleSlots = this.flashsaleSection.getElementsByClassName("flash-sale");
    Array.from(flashsaleSlots).forEach((anchor: HTMLAnchorElement, i: number) => {
      if (i < this.flashsaleData.length) {
        rootFlashsaleSlideRender(anchor, this.flashsaleData[i], this.isRenderedCallback);
      } else {
        const parentDiv = anchor.parentElement;
        if (parentDiv !== null) {
          const parentContainer = parentDiv.parentElement;
          if (parentContainer !== null) {
            parentContainer.removeChild(parentDiv);
          }
        }
      }
    });
  }

  /**
   * Render swiper
   */
  private runRender(): void {
    this.flashsaleSection.style.display = "";

    this.swiper = new RootBannerSection(this.flashsaleSection);
  }
}
